import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import * as storage from "utils/local-storage";
import { IS_INTEGRATED_APP, TOKEN, USER_ID, REFRESH_TOKEN } from "utils/constants";

export interface IntegratedAppSlice {
  isIntegratedApp: boolean;
  state: IntegratedAppState;
  userId?: string;
  token?: string;
  refreshToken?: string;
}

export enum IntegratedAppState {
  UNDEFINED,
  NOT_INTEGRATED,
  INTEGRATED_ANONYMOUS,
  INTEGRATED_SESSION_INITIALIZING,
  INTEGRATED_SESSION_INITIALIZED,
}

const initialState: IntegratedAppSlice = {
  isIntegratedApp: false,
  state: IntegratedAppState.UNDEFINED
};

const slice = createSlice({
  name: "integratedApp",
  initialState,
  reducers: {
    setIntegratedState: (state, action) => {
      storage.local.setItem(IS_INTEGRATED_APP, "true");

      state.state = action.payload.state;
      state.isIntegratedApp = action.payload.isIntegratedApp;
      state.userId = action.payload.userId;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;

      if (state.userId) {
        storage.local.setItem(USER_ID, state.userId);
      }
      if (state.token) {
        storage.local.setItem(TOKEN, state.token);
      }
      if (state.refreshToken) {
        storage.local.setItem(REFRESH_TOKEN, state.refreshToken);
      }

      return state;
    },
    removeIntegratedState: (state) => {
      storage.local.removeItem(IS_INTEGRATED_APP);
      storage.local.removeItem(USER_ID);
      storage.local.removeItem(TOKEN);
      storage.local.removeItem(REFRESH_TOKEN);

      state.state = IntegratedAppState.NOT_INTEGRATED;
      state.isIntegratedApp = false;
      state.userId = "";
      state.token = "";
      state.refreshToken = "";

      return state;
    }
  },
});

export const { setIntegratedState, removeIntegratedState } = slice.actions;

export const getIntegratedAppState = (state: RootState): IntegratedAppSlice => state.integratedApp;

export default slice.reducer;
